declare global {
  interface Window {
    gtag: (command: string, ...args: unknown[]) => void;
  }
}

/**
 * Track a custom event in Google Analytics
 */
export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

/**
 * Track a download click
 */
export function trackDownload(version: string, url: string) {
  trackEvent('download', {
    app_version: version,
    download_url: url,
    file_name: url.split('/').pop() || 'unknown',
  });
}

